<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm">
          <button type="button" class="btn btn-link btn-l" @click="$router.go(-1)">&#8592;</button>
        </div>
        <div class="col-sm">
          <progress-bar :options="options" :value="80" />
        </div>
        <div class="col-sm">
          <!-- <button type="button" class="btn btn-link btn-r"
            :disabled="!this.screening.value" @click="checkForConsent()">&#8594;</button> -->
        </div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4 card">
          <img class="img" :src="data.regionsScr.image.url" />
          <div class="clearfix"></div>
          <h6 v-html="data.regionsScr.header"></h6>
          <div class="clearfix"></div>
          <!-- No mobile -->
          <div v-if="!isPhone" class="btn-toolbar text-center"
            role="toolbar" aria-label="Toolbar with button groups">
            <div class="btn-group-toggle" role="group"
              v-for="opt in data.regionsScr.options" :value="opt.value" v-bind:key="opt.label">
              <label class="btn btn-primary btn-lg radio-btn"
                @click="toggleActive($event)"
                :class="{
                'no': parseInt(opt.value) === 2,
                'unsure': parseInt(opt.value) === 3
                }">
                <input type="radio"
                v-model="screening"
                :value="{ q: data.regionsScr.header, value: opt.value }"
                autocomplete="off">{{ opt.label }}
              </label>
            </div>
          </div>
          <!-- Mobile -->
          <div v-if="isPhone">
            <div class="btn-group-toggle"
              v-for="opt in data.regionsScr.options" :value="opt.value" v-bind:key="opt.label">
              <label class="btn btn-primary btn-lg radio-btn"
                @click="toggleActive($event)"
                :class="{
                'no': parseInt(opt.value) === 2,
                'unsure': parseInt(opt.value) === 3
                }">
                <input type="radio"
                v-model="screening"
                :value="{ q: data.regionsScr.header, value: opt.value }"
                autocomplete="off">{{ opt.label }}
              </label>
              <div class="clearfix"></div>
            </div>
          </div>
          <small class="disclaimer" v-html="disclaimer"></small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'
import $ from 'jquery'

export default {
  name: 'scrregion',
  components: {},
  data () {
    return {
      data: null,
      language: sessionStorage.getItem('language'),
      isDev: process.env.NODE_ENV === 'dev',
      isQa: process.env.NODE_ENV === 'qa',
      isPhone: isMobile,
      screening: {
        q: '',
        value: ''
      },
      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          dynamicPosition: false,
          hideText: true
        },
        progress: {
          color: '#82ab5b',
          backgroundColor: '#B8C9B8',
          inverted: false
        },
        layout: {
          height: 15,
          width: !isMobile ? $(window).width() - 600 : $(window).width() - 100,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'line'
        }
      }
    }
  },
  methods: {
    toggleActive (event) {
      $('.radio-btn').not(event.target).removeClass('active')
      $(event.target).parents('label').toggleClass('active')
    }
  },
  watch: {
    screening (scr) {
      if (scr && scr.value) {
        sessionStorage.setItem('currentlyLivingInMentionedRegions', this.screening.value)
        if (this.screening.value === '2' || this.screening.value === '3') { // No / Dont know
          this.$router.push('/off')
        } else {
          this.$router.push('/cnsnt')
        }
      }
    }
  },
  computed: {
    disclaimer () {
      if (this.data.regionsScr) {
        return this.data.regionsScr.disclaimer.replace('{1177}',
          '<a href="https://www.1177.se/Stockholm/liv--halsa/sexuell-halsa/" target="_blank">1177</a>')
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          regionsScr(locale: ` + sessionStorage.getItem('language') + `) {
            header
            options {
              label
              value
            }
            image {
              url
            }
            disclaimer
          }
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            nextBtn
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
button:disabled {
  opacity: 0.3;
}
.img {
  border-radius: 10px;
  width: 10vw;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 1200px) {
  .img {
    height: 30vh;
  }
}
.alert-error {
  display: none;
}
.no {
  background: #06755f94 !important;
  color: #29381a !important;
}
.no:active {
  background: #035a498c !important;
  color: #29381a !important;
}
.unsure {
  background: #6fa38d !important;
  color: #233510 !important;
}
.unsure:active {
  background: #6C8C7E !important;
  color: #233510 !important;
}
.radio-btn {
  margin-bottom: 1.4em;
  margin-right: .4em;
  border-color: #069ccc;
  background: #fff;
  color: #000;
  font-size: 1.1em;
  border-radius: .3rem !important;
  width: 9vw;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .radio-btn {
    margin-bottom: .05em;
    padding: .3em;
    width: 100%;
  }
  .container {
    margin-bottom: -7.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrRegion.vue